import {Injectable} from '@angular/core';
import {BehaviorSubject, of} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {EInvoiceApiService} from '@app/services/api/e-invoice-api.service';
import {FeatureFlagService} from '@app/services/feature-flag.service';
import {AccountFeaturesEnum} from '@app/interfaces/config/accountFeaturesEnum';

@Injectable({
  providedIn: 'root'
})
export class EInvoiceBadgeService {
  private incomingSubject = new BehaviorSubject<number>(0);
  private invoicesSubject = new BehaviorSubject<number>(0);
  private advancesSubject = new BehaviorSubject<number>(0);
  private totalSubject = new BehaviorSubject<number>(0);

  incoming$ = this.incomingSubject.asObservable();
  invoices$ = this.invoicesSubject.asObservable();
  advances$ = this.advancesSubject.asObservable();
  total$ = this.totalSubject.asObservable();

  get incomingCount(): number { return this.incomingSubject.value; }
  get invoicesCount(): number { return this.invoicesSubject.value; }
  get advancesCount(): number { return this.advancesSubject.value; }
  get totalCount(): number { return this.totalSubject.value; }

  constructor(
    private eInvoiceApi: EInvoiceApiService,
    private featureFlagService: FeatureFlagService,
  ) {
  }

  loadCounts(): void {
    this.featureFlagService.getFeatureFlags().subscribe((flags) => {
      if (!flags[AccountFeaturesEnum.FEATURE_FLAG_EINVOICE_INTEGRATION]) {
        return;
      }

      this.eInvoiceApi.getBadgeCounts()
        .pipe(catchError((err) => {
          console.error('Failed to load e-invoice badge counts', err);
          return of(null);
        }))
        .subscribe((result) => {
          if (!result) {
            return;
          }
          this.incomingSubject.next(result.data.incoming_action_needed ?? 0);
          this.invoicesSubject.next(result.data.outgoing_invoices_payment_needed ?? 0);
          this.advancesSubject.next(result.data.outgoing_advances_payment_needed ?? 0);
          this.totalSubject.next(result.data.total ?? 0);
        });
    });
  }

  refresh(): void {
    this.loadCounts();
  }
}
